import React, {useEffect, useState} from "react";
import Baselining from "./Baselining.page";

function BaseliningCyber() {
    return <Baselining/>
}

export default BaseliningCyber;